import { useEffect } from 'react';

/**
 * Moves keyboard/screen-reader focus to the page's `<main id="main">` on mount.
 * SPA navigations don't move focus by default; authenticated pages call this so
 * users land on content after routing (e.g. post-sign-in). Sign-in itself does
 * NOT call it, preserving its skip-link-first tab order.
 */
export function useFocusMain(): void {
  useEffect(() => {
    document.getElementById('main')?.focus();
  }, []);
}
